import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Message from '../../components/Message';
import {setMessageShow, setMessageText} from './messageSlice';
import {sleep} from '../../utils/helpers';

function MessageFeature() {
  const dispatch = useDispatch();
  const {
    message: {flash, text, type, show},
  } = useSelector(state => state);

  const handleClose = () => {
    dispatch(setMessageShow(false));
    sleep(200).then(() => {
      dispatch(setMessageText(''));
    });
  };

  return (
    <Message
      flash={flash}
      text={text}
      show={show}
      type={type}
      onClose={flash ? handleClose : undefined}
    />
  );
}

export default MessageFeature;
